angular.module('zc.projects.heatmap')
  .component('zcHeatmapList', {
    templateUrl: '/templates/projects.heatmap/heatmap_list.html',
    controller: function($scope) {
      $scope.pages = [{
        id: 1,
        url: 'http://www.mtgec.jp/shop/default.aspx',
        name: 'http://www.mtgec.jp/shop/default.aspx'
      }];
    },
    bindings: {
      project: '<'
    }
  });




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.heatmap/heatmap_list.component.js